import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '9519fbb0-4ff6-4525-ab9c-f526919ec803',
    countryCodes: ['IT'],
    locale: 'it-IT',
    isPrive: true,
});
